import axios, { api } from "./axios";

const setAuthToken = (token,auth) => {
    if (token) {
        // Adding header type for HTTP Request
        (auth ? api : axios).defaults.headers.common["Authorization"] = "Bearer " + token;
    } else {
        delete (auth ? api : axios).defaults.headers.common["Authorization"];
    }
};


export default setAuthToken

